var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_3946",
    "data-name": "Group 3946",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21.894 15.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3946-2",
    "data-name": "Group 3946",
    transform: "translate(1.121 8.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3945",
    "data-name": "Group 3945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4866",
    "data-name": "Path 4866",
    d: "M39.291,277.251l-1.834,1.84a2.03,2.03,0,0,1-2.812,0l-1.834-1.84-6.586,6.607a1.9,1.9,0,0,0,.8.181H45.075a1.9,1.9,0,0,0,.8-.181Z",
    transform: "translate(-26.226 -277.251)",
    fill: "#0d0404"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948",
    transform: "translate(1.122 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4867",
    "data-name": "Path 4867",
    d: "M45.076,76H27.031a1.9,1.9,0,0,0-.8.181l7.038,7.061h0l2.288,2.3a.77.77,0,0,0,1,0l2.288-2.3v0h0l7.038-7.061A1.9,1.9,0,0,0,45.076,76Z",
    transform: "translate(-26.228 -76)",
    fill: "#0d0404"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950",
    transform: "translate(0 1.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3949",
    "data-name": "Group 3949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4868",
    "data-name": "Path 4868",
    d: "M.2,101.212a1.9,1.9,0,0,0-.2.846V113.6a1.9,1.9,0,0,0,.2.846l6.6-6.619Z",
    transform: "translate(0 -101.212)",
    fill: "#0d0404"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952",
    transform: "translate(15.092 1.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3951",
    "data-name": "Group 3951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4869",
    "data-name": "Path 4869",
    d: "M359.53,101.21l-6.6,6.619,6.6,6.619a1.9,1.9,0,0,0,.2-.846V102.056A1.9,1.9,0,0,0,359.53,101.21Z",
    transform: "translate(-352.933 -101.21)",
    fill: "#0d0404"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0b3eccab139905d5b169dc9ae2d80482.svg";
export { ForwardRef as ReactComponent };